// src/config/api.js

/**
 * 🛡️ RAQMOON STRICT API RESOLVER
 * Ensures 1000% isolation between Dev and Prod environments.
 * No hardcoded fallbacks allowed.
 */

const envUrl = import.meta.env.VITE_API_BASE_URL;

if (!envUrl) {
  console.error("❌ CRITICAL ERROR: VITE_API_BASE_URL is not defined in the environment!");
}

export const baseURL = envUrl;

// Debug log to confirm environment at runtime (helpful for Admin inspection)
if (import.meta.env.DEV) {
  console.log(`%c 🛰️ Raqmoon API: ${baseURL} [${import.meta.env.MODE}]`, "color: #ff9800; font-weight: bold;");
}




